import React from 'react'
import { Formik } from 'formik'
import { usePestPacNoteOptionsSelector } from '@user/components/Notes/EditNoteDrawer/hooks/useNoteLocationSelector'
import { useHandlers } from './hooks/useHandlers'
import { BulkAddNoteFormFields } from './BulkAddNoteFormFields'
import { ILead } from '@user/store/lead'
import { IOpportunity } from '@user/store/opportunity'
import Alert from '@mui/material/Alert'
import Typography from '@mui/material/Typography'
import { ENTITY_TYPES } from '@sales-center/common'

type Props = {
  onClose?: () => void
  data: (ILead | IOpportunity)[]
  entityType: ENTITY_TYPES
}

export function BulkAddNoteFormWrapper(props: Props) {
  const { data, entityType, onClose } = props
  const { noteCodes } = usePestPacNoteOptionsSelector()

  const { onSubmit, validate } = useHandlers({ entityType, onClose })

  const filterExternalLocationIDData = data?.filter(
    (row) => row.externalLocationId,
  )

  const hasMatchedRecords =
    filterExternalLocationIDData?.length > 0 ? true : false

  return (
    <Formik
      onSubmit={onSubmit}
      validate={validate}
      initialValues={{
        ids: data?.map((row) => row?.id),
        Note: '',
        addToPestPacLocation: hasMatchedRecords,
        noteCode:
          hasMatchedRecords && noteCodes.find((code) => code.isDefault)?.name
            ? noteCodes.find((code) => code.isDefault)?.name
            : '',
      }}
    >
      <>
        {hasMatchedRecords && (
          <Alert severity="warning">
            <Typography variant="body2">
              For any selected unmatched records, the note will be added in
              Sales Center. For any selected matched records, the note will be
              added to all service locations in PestPac with the selected Note
              Code (if the &lsquo;Add Note to PestPac Location&lsquo; toggle is
              on).
            </Typography>
          </Alert>
        )}
        <BulkAddNoteFormFields
          noteCodes={noteCodes}
          externalLocationId={hasMatchedRecords ? 'yes' : undefined}
        />
      </>
    </Formik>
  )
}
